import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { UiTranslateModule } from '@fcom/ui-translate';
import { PipesModule } from '@fcom/common/pipes';

import { IconsModule } from '../icons';
import { NotificationsModule } from '../notifications/notifications.module';
import { ImagesModule } from '../images/images.module';
import { ButtonModule } from '../buttons/button.module';
import { ProductCardComponent } from './product-card/product-card.component';
import { SelectableCardComponent } from './selectable-card/selectable-card.component';
import { SelectableCardHeaderComponent } from './selectable-card/selectable-card-header.component';
import { SelectableCardContentComponent } from './selectable-card/selectable-card-content.component';
import { SelectableCardFooterComponent } from './selectable-card/selectable-card-footer.component';
import { TagModule } from '../tag';

@NgModule({
  declarations: [
    ProductCardComponent,
    SelectableCardComponent,
    SelectableCardHeaderComponent,
    SelectableCardContentComponent,
    SelectableCardFooterComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IconsModule,
    ImagesModule,
    ButtonModule,
    NotificationsModule,
    TagModule,
    UiTranslateModule,
    PipesModule,
  ],
  exports: [
    ProductCardComponent,
    SelectableCardComponent,
    SelectableCardHeaderComponent,
    SelectableCardContentComponent,
    SelectableCardFooterComponent,
  ],
})
export class ProductsModule {}
